module.exports = __webpack_public_path__ + "img/fmk-environment-logo.4f7b39f7.png";